import WebSocketService from "./WebSocketService";

interface AsWsApiProps {
    ws: WebSocketService
}

export class AsWsApi {
    ws: WebSocketService
    constructor(props: AsWsApiProps) {
        this.ws = props.ws
    }


    switchWorksTo(state: boolean){
        state ?
            this.ws.sendMessage('addSwitchableCalc',  { list: [{ entityType: 'fieldOp'}]})
            : this.ws.sendMessage('removeSwitchableCalc', { list: [{ entityType: 'fieldOp'}]})
        // this.ws.send()
    }
}